export default "__VITE_ASSET__BfyfMhg4__"